import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import * as validationService from "../../../devices/add-device-modal/validationService";

function TargetTypeNameField({
    id = "name",
    label = "Name",
    placeholder,
    value,
    onValueChange,
    required = true,
    valid,
    className = ""
}) {
    useEffect(() => {
        validationService.validateNotEmpty(value, "name");
        return () => validationService.cleanValidation("name");
    }, [value]);

    const [touched, setTouched] = useState(false);
    const fieldClassName = [
        "target-type-wizard-field",
        className
    ].filter(Boolean).join(" ");

    return (
        <div className={fieldClassName}>
            <label htmlFor={id} className="target-type-wizard-field__label">
                {label}
                {required ? <span className="modal-v2-required-mark">*</span> : null}
            </label>
            <input
                id={id}
                className={`target-type-wizard-input ${(valid && touched) ? "is-invalid" : ""}`}
                value={value || ""}
                onFocus={() => setTouched(true)}
                onChange={(event) => onValueChange(event.target.value)}
                placeholder={placeholder || `Enter ${label.toLowerCase()}`}
            />
        </div>
    );
}

function mapStateToProps(state) {
    return {
        valid: state.validation.name
    };
}

export default connect(mapStateToProps)(TargetTypeNameField);
